'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { type DetailedNavElement, useDetailedNavigation } from '@/components/DetailedView/DetailedNavigationProvider';
import { parseLink } from '@/components/Header/utils';
import { MetricCard, StatisticCard } from '@/components/Metrics/MetricCard';
import { DataGroup } from '@/payload/blocks/TopicBlock/DataGroup';
import { LastUpdatedComponent } from '@/payload/blocks/TopicBlock/LastUpdatedComponent';
import { structureTopicBlockData } from '@/payload/blocks/TopicBlock/utils';
import { formatSlug } from '@/payload/fields/slug/formatSlug';
import { type TopicBlock } from '@/payload/payload.types';
import { TopicBlockLayout } from './TopicBlockLayout';
export const TopicBlockComponent: React.FC<TopicBlock & {
  id?: string;
  borderBottom?: boolean;
  draft: boolean;
}> = props => {
  const $ = _c(35);
  const {
    setNavigationData
  } = useDetailedNavigation();
  const {
    link,
    includeLink,
    description,
    borderBottom,
    type,
    count,
    updatedCollections,
    draft
  } = props;
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== borderBottom || $[1] !== count || $[2] !== description || $[3] !== draft || $[4] !== includeLink || $[5] !== link || $[6] !== props || $[7] !== setNavigationData || $[8] !== type || $[9] !== updatedCollections) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        title,
        data,
        tag
      } = structureTopicBlockData(props);
      if (!data) {
        t7 = null;
        break bb0;
      }
      let t8;
      if ($[19] !== includeLink || $[20] !== link) {
        t8 = includeLink ? parseLink(link) : null;
        $[19] = includeLink;
        $[20] = link;
        $[21] = t8;
      } else {
        t8 = $[21];
      }
      const parsedLink = t8;
      if (type === "last-updated") {
        let t9;
        if ($[22] !== count || $[23] !== draft || $[24] !== updatedCollections) {
          t9 = <LastUpdatedComponent limit={count} types={updatedCollections} draft={draft} />;
          $[22] = count;
          $[23] = draft;
          $[24] = updatedCollections;
          $[25] = t9;
        } else {
          t9 = $[25];
        }
        t7 = <TopicBlockLayout link={parsedLink} id={formatSlug(title || "")} title={title} subTitle={tag} extra={description} borderBottom={borderBottom} asChild={true}>{t9}</TopicBlockLayout>;
        break bb0;
      }
      const handleClick = function handleClick(id) {
        if (!data) {
          return;
        }
        setNavigationData(data.reduce(_temp, [] as DetailedNavElement[]), id);
      };
      T0 = TopicBlockLayout;
      t0 = parsedLink;
      t1 = formatSlug(title || "");
      t2 = title;
      t3 = tag;
      t4 = description;
      t5 = borderBottom;
      t6 = data.map((doc, index) => {
        if (doc.type === "metrics") {
          return <MetricCard onClick={() => {
            handleClick(doc.raw.id);
          }} key={`metric-${index}`} parsedMetric={doc.value} rawMetric={doc.raw} />;
        }
        if (doc.type === "statistics") {
          return <StatisticCard onClick={() => {
            handleClick(doc.raw.id);
          }} key={`metric-${index}`} data={doc.value} />;
        }
        return <DataGroup onClick={id_0 => {
          handleClick(id_0);
        }} key={`group-${index}`} orderIndex={doc.orderIndex} docs={doc.value} />;
      });
    }
    $[0] = borderBottom;
    $[1] = count;
    $[2] = description;
    $[3] = draft;
    $[4] = includeLink;
    $[5] = link;
    $[6] = props;
    $[7] = setNavigationData;
    $[8] = type;
    $[9] = updatedCollections;
    $[10] = T0;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    T0 = $[10];
    t0 = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[26] !== T0 || $[27] !== t0 || $[28] !== t1 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
    t8 = <T0 link={t0} id={t1} title={t2} subTitle={t3} extra={t4} borderBottom={t5}>{t6}</T0>;
    $[26] = T0;
    $[27] = t0;
    $[28] = t1;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
};
function _temp(acc, item) {
  if (item.type === "metrics") {
    acc.push({
      type: "metric",
      id: item.raw.id
    });
  }
  if (item.type === "statistics") {
    acc.push({
      type: "statistic",
      id: item.raw.id
    });
  }
  if (item.type === "group") {
    item.value.forEach(item_0 => {
      acc.push({
        type: item_0.type === "metrics" ? "metric" : "statistic",
        id: item_0.raw.id
      });
    });
  }
  return acc;
}